import { ChoicePicker, ChoicePickerOption } from "./ChoicePicker";
import { useTranslation } from "react-i18next";


interface DigitalContentPickerProps {
    setDigitalContent: (data: any) => void;
    required?: boolean;
    value: DigitalContentOption | undefined;
}

export interface DigitalContentOption extends ChoicePickerOption {
    id: string;
    name: string
}

export const DigitalContentPicker = (props: DigitalContentPickerProps) => {
    const { t } = useTranslation();
    
    const data: ChoicePickerOption[] = [
        {id: "cars", name: t("txt_digital_content_cars")},
        {id: "travel", name: t("txt_digital_content_travel")},
        {id: "politics", name: t("txt_digital_content_politics")},
        {id: "food", name: t("txt_digital_content_food")},
        {id: "electronics", name: t("txt_digital_content_electronics")},
    ]

    data.sort((a, b) => {
        let x = a.name.toLowerCase()
        let y = b.name.toLowerCase()
        if (x < y) return -1
        if (x > y) return 1
        return 0
    })

    return (
        <ChoicePicker
            setSelectedData={props.setDigitalContent}
            placeholder={t("txt_digital_content")}
            data={data}
            multiple={false}
            required={props.required}
            controlId="digitalContentPicker"
            value={props.value ? [props.value] : []}
        />
);
}